export function getLowestLeadTimeEntry(arr: any[]) {
  return arr.reduce(
    (min, item) =>
      (item.bookingLeadTime ?? Infinity) < (min.bookingLeadTime ?? Infinity) ? item : min,
    { bookingLeadTime: Infinity }
  );
}
